import { DocumentNode, gql } from '@apollo/client';
import { HStack, Text, VStack } from '@chakra-ui/react';
import * as React from 'react';

import { EAnswerVote } from '@/graphql-types/globalTypes';
import { ArrowDownIcon, ArrowUpIcon } from '@/imports/ui/chakra/feather';
import { DataPhTags } from '@/analytics';

import { UpvoteDownvoteFooter_AnswerFragment } from './graphql-types/UpvoteDownvoteFooter_AnswerFragment';

import { VoteButton } from './components/VoteButton';
import { useVoteButton } from './hooks/useVoteButton';

export const UpvoteDownvoteFooter: React.FC<{
  answer: UpvoteDownvoteFooter_AnswerFragment;
}> & { answerFragment: DocumentNode } = ({ answer }) => {
  const { handleVote } = useVoteButton(answer);
  return (
    <VStack align="start">
      {answer.currentUserCanRespondToPost && (
        <Text textStyle="compactStrong" color="gray.500">
          WAS THIS ANSWER HELPFUL
        </Text>
      )}
      <HStack>
        <VoteButton
          answer={answer}
          data-ph={DataPhTags.ANSWER_UPVOTE}
          handleVote={() => handleVote(EAnswerVote.UPVOTE)}
          userVotedForOption={answer.currentUserVote === EAnswerVote.UPVOTE}
          leftIcon={<ArrowUpIcon />}
        >
          {answer.numUpvotes}
        </VoteButton>
        <VoteButton
          answer={answer}
          data-ph={DataPhTags.ANSWER_DOWNVOTE}
          handleVote={() => handleVote(EAnswerVote.DOWNVOTE)}
          userVotedForOption={answer.currentUserVote === EAnswerVote.DOWNVOTE}
          leftIcon={<ArrowDownIcon />}
        >
          {answer.numDownvotes}
        </VoteButton>
      </HStack>
    </VStack>
  );
};

UpvoteDownvoteFooter.answerFragment = gql`
  fragment UpvoteDownvoteFooter_AnswerFragment on AnswerV2 {
    _id
    numUpvotes
    numDownvotes
    currentUserCanRespondToPost
    ...useAnswerVote_AnswerFragment
    ...VoteButton_AnswerFragment
  }
  ${useVoteButton.answerFragment}
  ${VoteButton.answerFragment}
`;
